import React from "react"

const AuthContext = React.createContext(null as any)

export default AuthContext